import {
  STOCK_CHECKING_ALL,
  STOCK_CHECKING_CREATE,
  STOCK_CHECKING_GET,
  STOCK_CHECKING_UPDATE,
  STOCK_CHECKING_DELETE,
} from '../../actions/types';

const initialState = {
  serials: null,
  isLoading: true,
  isCompleted: false,
};
export default function (state = initialState, action) {
  switch (action.type) {
    case STOCK_CHECKING_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case STOCK_CHECKING_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case STOCK_CHECKING_CREATE:
      return { isLoading: true, isCompleted: true };
    case STOCK_CHECKING_UPDATE:
      return { isLoading: true, isCompleted: true };
    case STOCK_CHECKING_DELETE:
      return { isLoading: true, isCompleted: true };
    default:
      return state;
  }
}
